import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { inject as I, getCurrentInstance as v, watch as m, onBeforeUnmount as p } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function h(e, o, u) {
  var f;
  const d = I(e, null);
  if (d === null)
    return;
  const r = (f = v()) === null || f === void 0 ? void 0 : f.proxy;
  m(u, a), a(u.value), p(() => {
    a(void 0, u.value);
  });
  function a(n, i) {
    if (!d)
      return;
    const t = d[o];
    i !== void 0 && s(t, i), n !== void 0 && c(t, n);
  }
  function s(n, i) {
    n[i] || (n[i] = []), n[i].splice(n[i].findIndex((t) => t === r), 1);
  }
  function c(n, i) {
    n[i] || (n[i] = []), ~n[i].findIndex((t) => t === r) || n[i].push(r);
  }
}
export {
  h as useInjectionInstanceCollection
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/composable/use-collection.js
// module id = 1575
// module chunks = 41